import "../styles/App.css";

const Title = ({ titleLabel }) => <h1 className="title">{titleLabel}</h1>;

export default Title;
